import type { SvgIconComponent } from "@mui/icons-material";
import FolderOffOutlinedIcon from "@mui/icons-material/FolderOffOutlined";
import RuleOutlinedIcon from "@mui/icons-material/RuleOutlined";
import type { CorpusScanKey } from "./corpus_scan_contract";

/** The icon on each scan's card. */
export const CORPUS_SCAN_ICONS: Record<CorpusScanKey, SvgIconComponent> = {
  missing_field: RuleOutlinedIcon,
  missing_section_files: FolderOffOutlinedIcon,
};
